import { filter } from 'lodash-es';
import { Form, useFormikContext } from 'formik';
import Button from '@mui/material/Button';
import { makeStyles } from 'tss-react/mui';
import * as Yup from 'yup';
import TextAreaField from './forms/text-area-field';
import { splitEmailInvitesBody } from '../utils/invites';

// email regex from yup's string validation
const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

export const newEmailInvitesSchema = Yup.object().shape({
  body: Yup.string()
    .test(
      'emails-valid',
      'All emails are valid',
      function (body) {
        const { path, createError } = this;
        const emails = splitEmailInvitesBody(body);
        if (!emails.length) {
          return createError({
            path,
            message: "At least one email is required"
          });
        }
        const invalid = filter(emails, (email) => !email.match(emailRegex));
        if (invalid.length) {
          return createError({
            path,
            message: `Some emails are not valid: ${invalid.join(', ')}`
          });
        }
        return true;
      }
    )
    .required('Emails are required')
});

const useStyles = makeStyles()((theme) => ({
  generateButton: {
    margin: theme.spacing(1, 0, 2, 0)
  }
}));

type Props = {
  disabled?: boolean;
};

const NewEmailInvitesForm = ({ disabled: formDisabled }: Props) => {
  const { isSubmitting } = useFormikContext();
  const { classes } = useStyles();
  const disabled = isSubmitting || formDisabled;
  return (
    <Form>
      <TextAreaField
        name="body"
        label="Emails to invite"
        disabled={disabled}
        helperText="Email addresses must be separated by commas or line breaks"
      />
      <Button
        type="submit"
        sx={{ mt: 2 }}
        disabled={disabled}
        variant="contained"
        color="primary"
        className={classes.generateButton}
      >
        Invite Emails
      </Button>
    </Form>
  );
};

export default NewEmailInvitesForm;
